import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_224: DocMigration = {
  maxSchemaVersion: "0.0.224",
  description: "Convert stair block room anchors to datum references",
  apply(json: any) {
    for (const blockId in json.stairBlocks) {
      const block = json.stairBlocks[blockId];
      if (block.startRoomAnchorId) {
        block.datumVerticalLower = { type: "ROOM", roomId: block.startRoomAnchorId };
        delete block.startRoomAnchorId;
      }
      if (block.endRoomAnchorId) {
        block.datumVerticalUpper = { type: "ROOM", roomId: block.endRoomAnchorId };
        delete block.endRoomAnchorId;
      }
      if (block.roomAnchorId) {
        block.datumVertical = { type: "ROOM", roomId: block.roomAnchorId };
        delete block.roomAnchorId;
      }
    }
    return json;
  },
};

export default migration_0_0_224;
